import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  TeamCheckService as TeamCheckApiService,
  TeamCheckInfoResponse,
  ConfirmTeamsRequest,
  TeamOptionResponse,
  CreateTeamRequest
} from '@solverml/api';

@Injectable({
  providedIn: 'root'
})
export class TeamCheckService {

  constructor(
    private teamCheckApiService: TeamCheckApiService
  ) { }

  async getInfo(videoId: string): Promise<TeamCheckInfoResponse> {
    if (!videoId) throw new Error('Video ID is required');
    return await lastValueFrom(this.teamCheckApiService.getTeamCheckInfo(videoId));
  }

  async confirmTeams(videoId: string, teamRedId: string, teamBlueId: string): Promise<any> {
    if (!videoId) throw new Error('Video ID is required');
    const payload: ConfirmTeamsRequest = { team_red_id: teamRedId, team_blue_id: teamBlueId };
    return await lastValueFrom(this.teamCheckApiService.confirmTeams(videoId, payload));
  }


  /**
   * Obtiene la lista de equipos compatibles con el video (mismo género, categoría, etc.)
   */
  async getAvailableTeams(videoId: string): Promise<TeamOptionResponse[]> {
    if (!videoId) throw new Error('Video ID is required');
    return await lastValueFrom(this.teamCheckApiService.getAvailableTeams(videoId));
  }

  /**
   * Crea un nuevo equipo asociado automáticamente al contexto del video.
   */
  async createTeam(videoId: string, teamData: CreateTeamRequest): Promise<TeamOptionResponse> {
    if (!videoId) throw new Error('Video ID is required');
    return await lastValueFrom(this.teamCheckApiService.createTeamForVideo(videoId, teamData));
  }

  /**
   * Obtiene solo los equipos participantes en el video (para el filtro de VideoWatch).
   */
  async getAssignedTeams(videoId: string): Promise<TeamOptionResponse[]> {
    if (!videoId) throw new Error('Video ID is required');
    // Asumiendo que el cliente generado ya tiene este método tras regenerar.
    // Si no, tendrás que regenerar el cliente primero.
    return await lastValueFrom(this.teamCheckApiService.getAssignedTeams(videoId));
  }

}
